module.exports = __webpack_public_path__ + "img/lingyu_bg_banner.min.83c7c340.jpg";